import React, { useEffect } from "react";

import classes from "./style.scss";

export type StickyBannerData = {
	iconClassName: string;
	key?: string;
	title?: string;
	description?: string;
	isShown?: boolean;
}

interface Props {
	bannerData: StickyBannerData;
	setStickyBannerData?: React.Dispatch<React.SetStateAction<StickyBannerData | null>>;
}

const StickyBanner : React.FC<Props> = ({
	bannerData,
	setStickyBannerData
}) => {
	const {
		iconClassName,
		key,
		title,
		description,
		isShown
	} = bannerData;

	const sessionStorageKey = `sticky-banner-${key}`;

	const sessionStorageValue = "hidden";

	useEffect(() => {
		if (key && bannerData && !bannerData?.isShown) {
			const storedData = sessionStorage.getItem(sessionStorageKey);
	
			if (storedData !== sessionStorageValue) {
				setStickyBannerData((prevData) => ({
					...prevData,
					isShown: true
				}));
			}
		}
	}, [bannerData, key, sessionStorageKey, setStickyBannerData]);

	const handleDismiss = () => {
		sessionStorage.setItem(sessionStorageKey, sessionStorageValue);

		setStickyBannerData((prevData) => ({
			...prevData,
			isShown: false
		}));
	};

	if (!isShown) {
		return null;
	}

	return (
		<div className={classes.stickyBanner}>
			<i className={iconClassName} />

			<div className={classes.textContent}>
				<span className={classes.title}>{title}</span>

				<span className={classes.description}>{description}</span>
			</div>

			<i className="fa-sharp fa-regular fa-close" onClick={handleDismiss}/>
		</div>
	);
};

export default StickyBanner;
